import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Mixpanel } from '../../config/Mixpanel'
import Constants from '../../common/constants'
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom'
import './index.css'

const cradFeatures = [
    "Industry-Verified Certification",
    "Lifetime Access to 3100+ More Courses",
    "Live Doubt Solving",
    "Industry-Relevant Projects"
]

const PricingCard = ({ razorpayHandler, onboardingData, handleSkip }) => {

    const [ loading, setLoading ] = useState(false)

    const navigate = useNavigate()

    return (
        <div className='rounded-2xl border-2 text-center border-[#1CA571] p-4 pricing-card-linear-gradient-background' >
            <p className='text-sm md:hidden font-semibold mb-3'>Get A Personalised Course & Grow 3x Faster</p>
            <p className='text-xl hidden md:block font-semibold mb-3 mt-2'>Would You Like To Be An Expert With Personalised Course?</p>
            <div className='hidden md:grid md:grid-cols-2 md:gap-x-8 mt-5'>
                {cradFeatures?.map((item, index) => (
                    <div key={index} className='bg-[#1A3A5A] flex items-center rounded-lg py-2 px-1 mt-2 justify-center'>
                        <FontAwesomeIcon icon={faCircleCheck} color='#4AAD60'/>
                        <p className='text-sm  ml-2 font-semibold'>{item}</p>
                    </div>
                ))}
            </div>
            <div className='flex w-full flex-col mt-4 gap-y-2 md:flex-row md:justify-between md:items-center md:gap-x-2'>
                <div className='bg-[#1CA571] md:w-1/2 flex justify-center cursor-pointer items-center p-2 rounded-lg' onClick={() => {
                    Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_TOP_PERSONALISE_PAYMENT)
                    setLoading(true)
                    razorpayHandler(() => setLoading(false))
                }}>
                    {loading ? <div className='flex justify-center items-center'>
                        <ClipLoader color='black' size={20} />
                    </div> : <>
                        <div>
                            <p className='font-semibold'>Unlock Personalised Course</p>
                            <p className='text-xs font-medium'>Early Bird Discount: ₹199 <span className='text-[#FF2633]'>₹</span><span className='text-[#FF2633] line-through'>1199</span></p>
                        </div>
                        <div className='ml-3'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Arrow.png?updatedAt=1694517910311" width={34} height={34} alt="right arrow" />
                        </div>
                    </>}
                </div>
                <p className='text-center font-semibold '>or</p>
                <div className='bg-[#0E2C4B] border-2 md:w-1/2 border-[#1983D0] cursor-pointer p-2 rounded-lg' onClick={() => {
                    Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS_TOP_NORMAL)
                    handleSkip()
                }}>
                    <p className='text-[#1983D0] font-semibold'>Continue To Standard Course (Free)</p>
                    <p className='text-xs font-medium'> Verified certificate not included</p>
                </div>
            </div>
        </div>
    )
}

export default PricingCard